import { RecommendationLabel } from '@wix/ambassador-premium-domains-v1-recommendation/types';
import { isExperimentOn, parseDomain } from '@wix/domains-serverless-interface';
import { DomainsApiClient } from '@wix/domains-serverless-interface/react-kit';
import { CoreDomainSearchStore } from '@wix/domains-search-suite';
import { usePremiumEssentialsContext } from '@wix/premium-fed-sdk/@premium-essentials';
import { ExperimentSpecs } from '../constants';
import { useDisplayPrices } from './useDisplayPrices';
export const useIsEarlyExactMatchEnabled = () => {
  var _usePremiumEssentials;
  return isExperimentOn((_usePremiumEssentials = usePremiumEssentialsContext(false)) == null || (_usePremiumEssentials = _usePremiumEssentials.experiments) == null ? void 0 : _usePremiumEssentials[ExperimentSpecs.EarlyExactMatchSuggestion]);
};
const resolvePreviewDomain = submittedDomain => {
  if (!submittedDomain) {
    return undefined;
  }
  const parsed = parseDomain(submittedDomain);
  return parsed.error || parsed.subdomain ? undefined : parsed.asciiDomain;
};
export const useExactMatchPreview = function (_temp) {
  let _ref = _temp === void 0 ? {} : _temp,
    _ref$enabled = _ref.enabled,
    enabled = _ref$enabled === void 0 ? true : _ref$enabled,
    productType = _ref.productType;
  const isEnabledByGate = useIsEarlyExactMatchEnabled();
  const submittedDomain = CoreDomainSearchStore.useSubmittedDomain();
  const previewDomain = resolvePreviewDomain(submittedDomain);
  const isEnabled = enabled && isEnabledByGate && Boolean(previewDomain);
  const _DomainsApiClient$hoo = DomainsApiClient.hooks.useCanPurchaseDomainSuite({
      domain: submittedDomain
    }, isEnabled, {
      useErrorBoundary: false
    }),
    data = _DomainsApiClient$hoo.data;
  const isAvailable = isEnabled && Boolean(data == null ? void 0 : data.canPurchase);
  const premium = (data == null ? void 0 : data.premium) ?? false;
  const _useDisplayPrices = useDisplayPrices(isAvailable && previewDomain ? [[{
      domain: previewDomain,
      premium
    }]] : [], productType),
    pricesByDomain = _useDisplayPrices.pricesByDomain,
    isPricingLoading = _useDisplayPrices.isLoading;
  if (!isAvailable || !previewDomain) {
    return {
      recommendation: undefined,
      isPricingLoading: false
    };
  }
  return {
    recommendation: {
      id: previewDomain,
      domain: previewDomain,
      premium,
      label: RecommendationLabel.EXACT_MATCH,
      price: pricesByDomain.get(previewDomain)
    },
    isPricingLoading
  };
};
//# sourceMappingURL=useExactMatchPreview.js.map